import React from 'react';
import { Card, Descriptions, Spin, Empty } from 'antd';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@tanstack/react-query';
import { getBlockById } from '@/api/properties';
import { useAuth } from '@/contexts/AuthContext';


interface BlockTabProps {
  blockId: string;
}

const BlockTab: React.FC<BlockTabProps> = ({ blockId }) => {
  const { t } = useTranslation(['properties', 'common']);
  const { firestoreUser } = useAuth();

  const { data: block, isLoading, error } = useQuery({
    queryKey: ['block', blockId],
    queryFn: () => getBlockById(blockId, firestoreUser!),
    enabled: !!blockId && !!firestoreUser,
    staleTime: 5 * 60 * 1000,
  });

  if (isLoading) {
    return (
      <Card>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px' }}>
          <Spin size="large" />
        </div>
      </Card>
    );
  }

  if (error || !block) {
    return (
      <Card>
        <Empty description={t('properties:block.notFound')} />
      </Card>
    );
  }

  return (
    <Card>
      <Descriptions bordered column={1}>
        <Descriptions.Item label={t('properties:block.fields.name')}>
          {block.name}
        </Descriptions.Item>
        
        <Descriptions.Item label={t('properties:block.fields.description')}>
          {block.description}
        </Descriptions.Item>
        
        <Descriptions.Item label={t('properties:block.fields.floors')}>
          {block.floors?.length ? `${block.floors.length} floor(s)` : '-'}
        </Descriptions.Item>
        
        {block.floors && block.floors.length > 0 && (
          <Descriptions.Item label={t('properties:block.fields.floorDetails')}>
            <div>
              {block.floors.map((floor, index) => (
                <div key={index}>
                  <strong>{floor.name}</strong> - {floor.description}
                </div>
              ))}
            </div>
          </Descriptions.Item>
        )}
        
        <Descriptions.Item label={t('properties:block.fields.images')}>
          {block.images?.length ? `${block.images.length} image(s)` : '-'}
        </Descriptions.Item>
      </Descriptions>
    </Card>
  );
};

export default BlockTab; 